import { useCallback, useState } from 'react';
export var useModal = function (initialState) {
    if (initialState === void 0) { initialState = false; }
    var _a = useState(initialState), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(), data = _b[0], setData = _b[1];
    var onClose = useCallback(function () {
        setIsOpen(false);
        setData(undefined);
    }, []);
    var onOpen = useCallback(function (data) {
        data && setData(data);
        setIsOpen(true);
    }, []);
    return { isOpen: isOpen, onClose: onClose, onOpen: onOpen, data: data };
};
